import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  z-index: 1000;

  span {
    background: #ff9000;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden;
    position: absolute;
    bottom: calc(100% + 12px);
    width: 160px;
    left: 20%;
    transform: translateX(-50%);

    color: #312e38;

    &::before {
      border-style: solid;
      border-color: #ff9000 transparent;
      border-width: 6px 6px 0 6px;
      content: '';
      top: 100%;
      position: absolute;
      left: 50%;
    }
  }
  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
